import { useState } from 'react';
import EventsModal from '../EventsModal';
import './events.css';

function EventsCard(props) {
    const { content, title, summary } = props;
    const [open, setOpen] = useState(false);

    // Extrair a primeira imagem e uma parte do texto para o resumo
    const firstImage = content.find(item => item.type === 'image');
    const firstImageSrc = firstImage ? (Array.isArray(firstImage.src) ? firstImage.src[0] : firstImage.src) : null;

    return (
        <div className="event-card">
            {firstImageSrc &&
                <div className="card-image-container">
                    <img src={firstImageSrc} alt={firstImage.alt || 'Imagem do projeto'} />
                </div>
            }
            <h3>{title}</h3>
            <p>{summary}</p>
            <button onClick={() => setOpen(true)}>Saiba mais</button>
            {open && <EventsModal {...props} setOpen={setOpen} />}
        </div>
    );
}

export default EventsCard;
